import { gsap } from "gsap";

class DrawerItem {

	constructor (params) {
		// Init variables
		this.$cache       = {};
		this.$cache.main  = params.target;
		
		this.isOpen = false;
		// Trigger init functions
		this.initCache();
		this.initEventConst();
		this.registerEvent();
	}

	initCache() {
		this.$cache.accordeonTitle  = this.$cache.main.find('.title-wrapper');
		this.$cache.content         = this.$cache.main.find('.content-wrapper');
		this.$cache.contentInner    = this.$cache.main.find('.inner-content');
		this.$cache.siblingItems    = this.$cache.main.parent().find('.js-drawer-item').not(this.$cache.main);
		if(this.$cache.siblingItems.length === 0) this.$cache.siblingItems = this.$cache.main.closest('.js-drawers-wrap').find('.js-drawer-item').not(this.$cache.main);
	}
	
	initEventConst() {
		this.toggleEvent = () => this.toggle();
		this.closeEvent = () => this.close();
	}

	registerEvent() {
		this.$cache.accordeonTitle.on('click', this.toggleEvent);
		this.$cache.main.on('closeAll', this.closeEvent);
	}

	open(triggerSiblings) {
		if(this.isOpen) return;
		this.isOpen = true;

		this.$cache.main.addClass('is-open');

		let h = this.$cache.contentInner.outerHeight();
		let tl = new gsap.timeline({paused: true});

		tl.add(() => {
			this.$cache.main.trigger('opening');
		   if(triggerSiblings) this.$cache.siblingItems.trigger('closeAll');
		}, 0);
		tl.to(this.$cache.content, 0.5, {height: h, force3D: true, ease: "quad.out"}, 0.05);
		tl.fromTo(this.$cache.contentInner, 0.6, {y: 30}, {y: 0, ease: "circ.out"}, 0.15);
		tl.fromTo(this.$cache.contentInner, 0.5, {opacity: 0}, {opacity: 1, ease: "quad.out"}, 0.15);

		tl.play();
	}

	close() {
		if(!this.isOpen) return;
		this.isOpen = false;
  
		let tl = new gsap.timeline({paused: true, onStart: () => {
			this.$cache.main.trigger('closing');
			this.$cache.main.removeClass('is-open');
		}});
		tl.to(this.$cache.contentInner, {duration: 0.4, opacity: 0, ease: "expo.out"}, 0.1);
		tl.to(this.$cache.content, {duration: 0.5, height: 0, ease: "quad.out"}, 0);
  
		tl.play();
	}
	
	toggle() {		
		if(this.isOpen) {
		  this.close();
		} else {
		  this.open(true);
		}
	}

	resize() {
		let bpLastValue = window.bp.lastValue;
		let bpValue = window.bp.value;
  
		// On breakpoint change
		if (bpLastValue !== bpValue || bpValue === 'xs') {
		  if(this.isOpen) {
			this.$cache.content.height(this.$cache.contentInner.outerHeight());
		  }
		}
	}
}

export default DrawerItem;


// WEBPACK FOOTER //
// ./scripts/components/drawer-item.js